import type { MapView } from '@/types/map'
import { REGIONS, getCountryLabel } from '@/assets/region-mapping'

export interface BreadcrumbsProps {
  view: MapView
  onNavigate: (level: MapView) => void
}

function labelFor(v: MapView): string {
  if (v.kind === 'globe') return 'GLOBE'
  if (v.kind === 'region') return REGIONS[v.slug].label.toUpperCase()
  if (v.kind === 'country') return getCountryLabel(v.iso2, v.iso2).toUpperCase()
  return 'SITE'
}

export function Breadcrumbs({ view, onNavigate }: BreadcrumbsProps) {
  const crumbs: MapView[] = view.kind === 'globe' ? [{ kind: 'globe' }] : [...view.history, view]

  return (
    <nav
      aria-label="breadcrumb"
      className="absolute left-3 top-3 z-10 flex items-center gap-1 rounded-md border border-[color:var(--border-subtle)] bg-[color:var(--surface-secondary)]/85 px-2.5 py-1 font-mono text-xs uppercase tracking-[0.14em] backdrop-blur"
    >
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1
        return (
          <span key={`${i}-${c.kind}`} className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => onNavigate(c)}
              className={
                isLast
                  ? 'font-medium text-[color:var(--interactive-primary)]'
                  : 'text-[color:var(--text-tertiary)] transition-colors hover:text-[color:var(--interactive-primary)]'
              }
            >
              {labelFor(c)}
            </button>
            {!isLast && (
              <span className="text-[color:var(--text-tertiary)]" aria-hidden>
                ›
              </span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
